import React from "react";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

export default function BonusFormRow({
  bonusFormData,
  handleBonusFrom,
  bonusValidation,
  disabled,
}) {
  return (
    <React.Fragment>
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          divider={<Divider orientation="vertical" flexItem variant="middle" />}
          spacing={5}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!bonusValidation?.bounsAmountErr}
              helperText={bonusValidation?.bounsAmountErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={bonusFormData.bounsAmount}
              type="number"
              id="outlined-basic"
              label="到數獎金金額"
              variant="outlined"
              onChange={(event) =>
                handleBonusFrom("bounsAmount", event.target.value)
              }
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          divider={<Divider orientation="vertical" flexItem variant="middle" />}
          spacing={5}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!bonusValidation?.specialBounsConditionErr}
              helperText={bonusValidation?.specialBounsConditionErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={bonusFormData.specialBounsCondition}
              type="number"
              id="outlined-basic"
              label="特別獎金達標數"
              variant="outlined"
              onChange={(event) =>
                handleBonusFrom("specialBounsCondition", event.target.value)
              }
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <TextField
              disabled={disabled}
              error={!!bonusValidation?.specialBounsAmountErr}
              helperText={bonusValidation?.specialBounsAmountErr}
              sx={{ maxWidth: 380, minWidth: 100 }}
              value={bonusFormData.specialBounsAmount}
              type="number"
              id="outlined-basic"
              label="特別獎金金額"
              variant="outlined"
              onChange={(event) =>
                handleBonusFrom("specialBounsAmount", event.target.value)
              }
              InputProps={{
                inputProps: {
                  min: 0,
                },
                startAdornment: (
                  <InputAdornment position="start">$</InputAdornment>
                ),
              }}
            />
          </Box>
        </Stack>
      </Box>
    </React.Fragment>
  );
}
